import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 45, height: 50, viewBox: "0 0 45 50", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25.5 25.3301L18 29.6603V21L25.5 25.3301Z", fill: "black" }));
export default SvgPlay;
